import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { Col, Row, Button, FormGroup, Label, Input } from "reactstrap";
import axios from "axios";
import ImageUploading from "react-images-uploading";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Spinner } from "reactstrap";
import DownloadIcon from '@mui/icons-material/Download';
import styled from 'styled-components';
import moment from 'moment-timezone';
import { trackPromise } from "react-promise-tracker";
import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import classes from "./TruckForm.module.scss";
import _ from "lodash";
import profileIcon from "./../../../../assets/icons/profilePictureBase64";
import Form from "./../../../general/Form/Form";
import FileUpload from "./../../../general/TruckImageUpload/TruckImageUpload";
import blobify from "./TruckImageBlobifier";
//import heicToJpg from "./heicFileConversionService";
import Table from "./../../../general/Table/Table";
import TruckImageLightbox from "./../../../general/TruckImageLightbox/TruckImageLightbox";
import EditProblemModal from "./../../fixlist/EditProblemModal/EditProblemModal";

//const FormData = require('form-data');

axios.defaults.withCredentials = true;

const Image = styled.img`
  height: 100%;
  object-fit: cover;
  cursor: pointer;
  ${props => props.width === 'auto' ? 'width: auto' : 'width: 100%'}
`;

const FullScreenModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const Arrow = styled.div`
  color: white;
  font-size: 2rem;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${props => props.direction === 'left' ? 'left: 15px' : 'right: 15px'}
`;

const initialState = {
  truckId: null,
  truckName: "",
  licensePlate: "",
  make: "",
  year: "",
  sizeRef: "",
  sideDim: "",
  backDim: "",
  overCabDim: "",
  areaCovered: "",
  milesPerDay: "",
  movesFreightFor: "",
  startingLocation: "",
  sideDoor: false,
  sideRail: false,
  coloredCab: false,
  backdoorLiftGate: false,
  description: "",
  vendorId: null,
  loadedTruck: false,
  truckPictures: [],
  truckPicturesToDelete: [],
  newImages: [],
  showLightbox: false,
  lightboxIndex: 0,
  truckFixListData: [],
  closedTruckFixListData: [],
  problemModalShow: false,
  problemModalEdit: false,
  closedFixListShow: false,
  taggedTrucks: [],
  fullScreen: false,
  currentImage: 0,
  accordainIndex: 0,
  isImageDownloading: false,
};

class TruckForm extends Component {
  state = initialState;

  onFormSubmitHandler = async (e) => {
    e.preventDefault();

    let truck = {
      name: this.state.truckName,
      license_plate: this.state.licensePlate,
      make: this.state.make,
      year: this.state.year,
      size_ref: this.state.sizeRef,
      side_dim: this.state.sideDim,
      back_dim: this.state.backDim,
      over_cab_dim: this.state.overCabDim,
      area_covered: this.state.areaCovered,
      miles_per_day: this.state.milesPerDay,
      moves_freight_for: this.state.movesFreightFor,
      starting_location: this.state.startingLocation,
      side_door: this.state.sideDoor ? this.state.sideDoor : false,
      side_rail: this.state.sideRail ? this.state.sideRail : false,
      colored_cab: this.state.coloredCab ? this.state.coloredCab : false,
      backdoor_lift_gate: this.state.backdoorLiftGate ? this.state.backdoorLiftGate : false,
      description: this.state.description,
      vendor_id: this.state.vendorId,
      new_images: this.state.newImages,
      //new_truck_picture: this.state.newTruckPicture
    };

    if (this.props.edit) {
      await trackPromise(this.props.update(truck));
      //check if user selected new file, if so we must call the upload handler function
      if (this.state.newImages.length != 0) {
        let uploadStatus = await trackPromise(this.truckUploadPictureHandler()).then(
          (result) => {
            window.location.reload();
          },
          (error) => {
            console.log(error);
          }
        );
      }
      if (this.state.truckPicturesToDelete != []) {
        let deleteStatus = await trackPromise(this.truckImageDeleteHandler());
      }
    } else {
      this.props.add(truck);
      // clear form
      this.setState(initialState);
    }
  };
  emptyTableRow = ["Nothing to display"];
  getTruckFixListData = () => {
    trackPromise(
      axios
        .get(`${process.env.REACT_APP_API_HOST}/truck/${this.state.truckId}/fixlist`, { withCredentials: true })
        .then((response) => {
          let closed_problems = [];
          let problems = response.data.problem
            .filter(function (problem) {
              if (problem.closed == true) {
                closed_problems.push(problem);
                return false;
              }
              return true;
            })
            .map((problem, index) => {
              return [
                problem.truck_problem_id,
                problem.description,
                moment(problem.date_identified).format("YYYY-MM-DD"),
                problem.bleeding_stopped,
                problem.reprint_ordered,
                problem.solution,
                moment(problem.target_close_date).format("YYYY-MM-DD"),
                problem.truck_id,
              ];
            });

          closed_problems = closed_problems.map((problem, index) => {
            return [
              problem.truck_problem_id,
              problem.description,
              moment(problem.date_identified).format("YYYY-MM-DD"),
              problem.bleeding_stopped,
              problem.reprint_ordered,
              problem.solution,
              moment(problem.target_close_date).format("YYYY-MM-DD"),
              problem.truck_id,
            ];
          });
          if (closed_problems.length > 0) {
            this.setState({
              closedFixListShow: true,
            });
          } else {
            this.setState({
              closedFixListShow: false,
            });
          }
          // sort clients by name alphabetically ascending
          problems = problems.sort((a, b) => {
            let first = a[1].toUpperCase();
            let second = b[1].toUpperCase();
            return (first === "") - (second === "") || +(first > second) || -(first < second);
          });
          this.setState({
            truckFixListData: problems,
            closedTruckFixListData: closed_problems,
          });
        })
        .catch((err) => {
          console.log(err);
        })
    );
  };
  truckFixListHeaders = [
    "id",
    "Description",
    "Date Identified",
    "Bleeding Stopped",
    "Reprint Ordered",
    "Solution",
    "Target Close Date",
  ];
  truckFixListButtons = [
    {
      display: "View",
      onClickHandler: async (index, id) => {
        if (id) {
          this.setState({
            problemModalEdit: true,
            problemModalShow: true,
            problemModalData: {
              id: id,
            },
          });
        }
      },
    },
  ];
  closedTruckFixListButtons = [
    {
      display: "View",
      onClickHandler: (index, id) => {
        let problem = this.state.closedTruckFixListData.find((item) => item[0] === id);
        let data = {
          id: problem[0],
          vendor_name: problem[1],
          //truck_id: problem[3],
        };
        //console.log("id: " + id + " data: " + JSON.stringify(data));
        this.setState({
          modalEdit: true,
          modalData: data,
          modalShow: true,
        });
      },
    },
  ];

  toggleProblemModal = (refreshTable) => {
    this.setState({
      problemModalShow: false,
    });
    if (refreshTable) {
      this.getTruckFixListData();
    }
  };
  newProblemModal = () => {
    this.setState({
      problemModalEdit: false,
      problemModalShow: true,
      truckPageId: this.state.truckId,
    });
  };
  deleteTruckHandler = async (e) => {
    e.preventDefault();
    if (window.confirm(`Are you sure you want to delete this truck?\nThis action is irreversible.`)) {
      try {
        let res = await axios.delete(`${process.env.REACT_APP_API_HOST}/truck/${this.state.truckId}`, {
          withCredentials: true,
        });
        if (res.status === 200 && res.data.deleted_truck && res.data.deleted_truck[0].truck_id) {
          alert("Truck was deleted");
          this.props.history.push(`/dashboard/admin/drive/vendor/edit/${this.state.vendorId}`);
          return;
        }
      } catch (err) {
        console.log(err);
      }
      alert("There was a problem deleting the truck");
      window.location.reload();
    }
  };


  componentDidMount(){
    this.loadTruckInfo();
    this.getTruckFixListData();
  }

  loadTruckInfo = async () => {
    if(this.props.edit && this?.props?.match?.params?.id && !this.state.loadedTruck){
      try {
        // get truck information
  
        let res = await trackPromise(
          axios.get(`${process.env.REACT_APP_API_HOST}/truck/${this?.props?.match?.params?.id}`, { withCredentials: true })
        );
  
        let images = await trackPromise(
          axios.get(`${process.env.REACT_APP_API_HOST}/truck/${this?.props?.match?.params?.id}/images`, { withCredentials: true })
        );
        let truckImageData = images.data.images.map((file) => [file.truck_image_id, file.img_url, file.upload_date]);
        if (res.status === 200 && res.data.truck && res.data.truck.length === 1) {
          let truck = res.data.truck[0];
          this.loadTaggedTrucks(this?.props?.match?.params?.id, truck.vendor_id);
          this.setState({
            truckId: this?.props?.match?.params?.id,
            truckName: truck.name,
            licensePlate: truck.license_plate,
            make: truck.make,
            year: truck.year,
            sizeRef: truck.size_ref,
            sideDim: truck.side_dim,
            backDim: truck.back_dim,
            overCabDim: truck.over_cab_dim,
            areaCovered: truck.area_covered,
            milesPerDay: truck.miles_per_day,
            movesFreightFor: truck.moves_freight_for,
            startingLocation: truck.starting_location,
            sideDoor: truck.side_door,
            sideRail: truck.side_rail,
            coloredCab: truck.colored_cab,
            backdoorLiftGate: truck.backdoor_lift_gate,
            description: truck.description,
            vendorId: truck.vendor_id,
            loadedTruck: true,
            truckPictures: truckImageData,
          });
        }
      } catch (err) {
        console.log(err);
      }
    }
  }

  loadTaggedTrucks = async (truckId, vendorId) => {
    if (vendorId && truckId) {
      let loadedTaggedTrucks = await axios.get(`${process.env.REACT_APP_API_HOST}/comunication/get-all-truck-tagged-pictures?vendor_id=${vendorId}&truck_id=${truckId}`, { withCredentials: true })
      if (loadedTaggedTrucks?.data?.tagged_trucks && loadedTaggedTrucks?.data?.tagged_trucks.length > 0) {
        this.setState({
          taggedTrucks: [...loadedTaggedTrucks?.data?.tagged_trucks]
        })
      }
    }
  }

  loadTruck = async () => { };

  truckNameChangeHandler = (e) => {
    this.setState({
      truckName: e.target.value,
    });
  };

  licensePlateChangeHandler = (e) => {
    this.setState({
      licensePlate: e.target.value,
    });
  };

  makeChangeHandler = (e) => {
    this.setState({
      make: e.target.value,
    });
  };

  yearChangeHandler = (e) => {
    this.setState({
      year: e.target.value,
    });
  };

  sizeRefChangeHandler = (e) => {
    this.setState({
      sizeRef: e.target.value,
    });
  };

  sideDimChangeHandler = (e) => {
    this.setState({
      sideDim: e.target.value,
    });
  };

  backDimChangeHandler = (e) => {
    this.setState({
      backDim: e.target.value,
    });
  };

  overCabDimChangeHandler = (e) => {
    this.setState({
      overCabDim: e.target.value,
    });
  };

  areaCoveredChangeHandler = (e) => {
    this.setState({
      areaCovered: e.target.value,
    });
  };

  milesPerDayChangeHandler = (e) => {
    this.setState({
      milesPerDay: e.target.value,
    });
  };

  movesFreightForChangeHandler = (e) => {
    this.setState({
      movesFreightFor: e.target.value,
    });
  };

  startingLocationChangeHandler = (e) => {
    this.setState({
      startingLocation: e.target.value,
    });
  };

  sideDoorChangeHandler = (e) => {
    this.setState({
      sideDoor: e.target.checked,
    });
  };


  sideRailChangeHandler = (e) => {
    this.setState({
      sideRail: e.target.checked,
    });
  };

  coloredCabChangeHandler = (e) => {
    this.setState({
      coloredCab: e.target.checked,
    });
  };

  backdoorLiftGateChangeHandler = (e) => {
    this.setState({
      backdoorLiftGate: e.target.checked,
    });
  };

  descriptionChangeHandler = (e) => {
    this.setState({
      description: e.target.value,
    });
  };
  truckImageChangeHandler = (file) => {
    this.setState({
      newImages: file,
    });
  };
  truckUploadPictureHandler = async () => {
    let truck_id = this.state.truckId;
    let success = true;
    // Create an object of formData
    const formData = new FormData();
    let files = this.state.newImages;

    for (let i = 0; i < files.length; i++) {
      var blob = blobify(files[i].data_url);
      formData.append("images", blob, files[i].file_name);
    }
    // Update the formData object
    success = await axios({
      method: "post",
      url: `${process.env.REACT_APP_API_HOST}/truck/${this.state.truckId}/images`,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return success;
  };

  truckImageDeleteHandler = async () => {
    let truckPicturesToDelete = this.state.truckPicturesToDelete;
    let success = true;
    for (let id of truckPicturesToDelete) {
      let s3_url = id.s3_url;
      let res = await axios.delete(`${process.env.REACT_APP_API_HOST}/truck/images/${id.id}`, {
        withCredentials: true,
        data: { s3url: s3_url },
      });
      if (!(res.status === 200 && res.data.deleted_image && res.data.deleted_image[0].imageId)) success = false;
    }

    // Clear queue of files to delete
    this.state.vendorFilesToDelete = [];

    return success;
  };

  truckPictureHeaders = ["id", "Image", "Date Added"];
  truckPictureButtons = [
    {
      display: "View Full Size",
      onClickHandler: async (index, id) => {
        this.setState({
          lightboxIndex: index,
          showLightbox: true,
        });
      },
    },
    {
      display: "Download",
      onClickHandler: async (index, id) => {
        let img_url = this.state.truckPictures[index][1];
        window.open(img_url, "_blank");
      },
    },
    {
      display: "Delete",
      onClickHandler: async (index, id) => {
        let files = _.cloneDeep(this.state.truckPictures);
        let indexToRemove = files.findIndex((file) => file[0] === id);
        let s3_url = files[indexToRemove][1];
        files.splice(indexToRemove, 1);
        this.setState({
          truckPictures: files,
          truckPicturesToDelete: this.state.truckPicturesToDelete.concat({ id: id, s3_url: s3_url }),
        });
      },
    },
  ];

  openFullScreen (index, val) {
    this.setState({
      fullScreen: true,
      currentImage: index,
      accordainIndex: val
    })
  };
  
  closeFullScreen () {
    this.setState({
      fullScreen: false,
      currentImage: 0,
      accordainIndex: 0
    })
  };

  nextImage () {
    this.setState({
      currentImage: (this.state.currentImage + 1) % this.state.taggedTrucks[this.state.accordainIndex].image_urls.length
    })
  };
  
  previousImage () {
    this.setState({
      currentImage: (this.state.currentImage - 1 +  this.state.taggedTrucks[this.state.accordainIndex].image_urls.length) % this.state.taggedTrucks[this.state.accordainIndex].image_urls.length
    })
  };
  
  handleDownload = (url) => {
    this.setState({
      isImageDownloading: true
    })
    axios
    .get(`${process.env.REACT_APP_API_HOST}/communication/download-media/${encodeURIComponent(url)}`, {
      responseType: 'blob'
    })
    .then((response) => {
      const contentType = response.headers['content-type'];
      const blob = new Blob([response.data], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'downloaded-media';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.setState({
        isImageDownloading: false
      })
      })
      .catch((error) => {
        console.error('Error:', error);
        this.setState({
          isImageDownloading: false
        })
      });
    }
    
    render() {
      const sectionStyle = {
        boxShadow: "none",
        border: "1px solid rgba(0, 0, 0, 0.1)",
      };
      const buttonStyle = {
        float: "right",
        marginLeft: "20px",
        width: "100px",
    };
    console.log('testing..............',this.state.accordainIndex,this.state.currentImage)
    const enableLightbox = true;
    return (
      <Fragment>
        <Form title={this.props.edit ? "Edit Truck" : "Add Truck"}>
          <Row form className="pl-2 pr-2 mt-4">
            <Col xs={6} className="pl-4 pr-4">
              <FormGroup row>
                <Label xs={2}>Truck Name</Label>
                <Col xs={10} className="pt-2">
                  <Input
                    type="text"
                    value={this.state.truckName ? this.state.truckName : ""}
                    onChange={this.truckNameChangeHandler}
                    placeholder="Enter truck name"
                  />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label xs={2}>License Plate</Label>
                <Col xs={10} className="pt-2">
                  <Input
                    type="text"
                    value={this.state.licensePlate ? this.state.licensePlate : ""}
                    onChange={this.licensePlateChangeHandler}
                    placeholder="Enter license plate"
                  />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label xs={2}>Make</Label>
                <Col xs={10} className="pt-2">
                  <Input
                    type="text"
                    value={this.state.make ? this.state.make : ""}
                    onChange={this.makeChangeHandler}
                    placeholder="Enter truck make"
                  />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label xs={2}>Year</Label>
                <Col xs={10} className="pt-2">
                  <Input
                    type="text"
                    value={this.state.year ? this.state.year : ""}
                    onChange={this.yearChangeHandler}
                    placeholder="Enter truck year"
                  />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label xs={2}>Size Reference</Label>
                <Col xs={10} className="pt-2">
                  <Input
                    type="text"
                    value={this.state.sizeRef ? this.state.sizeRef : ""}
                    onChange={this.sizeRefChangeHandler}
                    placeholder="Enter truck size reference"
                  />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label xs={2}>Side Dimensions</Label>
                <Col xs={10} className="pt-2">
                  <Input
                    type="text"
                    value={this.state.sideDim ? this.state.sideDim : ""}
                    onChange={this.sideDimChangeHandler}
                    placeholder="Enter truck side dimensions"
                  />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label xs={2}>Back Dimensions</Label>
                <Col xs={10} className="pt-2">
                  <Input
                    type="text"
                    value={this.state.backDim ? this.state.backDim : ""}
                    onChange={this.backDimChangeHandler}
                    placeholder="Enter truck back dimensions"
                  />
                </Col>
              </FormGroup>
            </Col>
            <Col xs={6} className="pl-4 pr-4">
              <FormGroup row>
                <Label xs={2}>Over Cab Dimensions</Label>
                <Col xs={10} className="pt-2">
                  <Input
                    type="text"
                    value={this.state.overCabDim ? this.state.overCabDim : ""}
                    onChange={this.overCabDimChangeHandler}
                    placeholder="Enter truck over cab dimensions"
                  />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label xs={2}>Areas Covered</Label>
                <Col xs={10} className="pt-2">
                  <Input
                    type="text"
                    value={this.state.areaCovered ? this.state.areaCovered : ""}
                    onChange={this.areaCoveredChangeHandler}
                    placeholder="Enter areas covered by truck"
                  />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label xs={2}>Miles Per Day</Label>
                <Col xs={10} className="pt-2">
                  <Input
                    type="text"
                    value={this.state.milesPerDay ? this.state.milesPerDay : ""}
                    onChange={this.milesPerDayChangeHandler}
                    placeholder="Enter areas covered by truck"
                  />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label xs={2}>Moves Freight For</Label>
                <Col xs={10} className="pt-2">
                  <Input
                    type="text"
                    value={this.state.movesFreightFor ? this.state.movesFreightFor : ""}
                    onChange={this.movesFreightForChangeHandler}
                    placeholder="Enter areas covered by truck"
                  />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label xs={2}>Starting Location</Label>
                <Col xs={10} className="pt-2">
                  <Input
                    type="text"
                    value={this.state.startingLocation ? this.state.startingLocation : ""}
                    onChange={this.startingLocationChangeHandler}
                    placeholder="Enter areas covered by truck"
                  />
                </Col>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input type="checkbox" checked={!!this.state.sideDoor} onChange={this.sideDoorChangeHandler} /> Side
                  Door
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input type="checkbox" checked={!!this.state.sideRail} onChange={this.sideRailChangeHandler} /> Side
                  Rail
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input type="checkbox" checked={!!this.state.coloredCab} onChange={this.coloredCabChangeHandler} />{" "}
                  Colored Cab
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    checked={!!this.state.backdoorLiftGate}
                    onChange={this.backdoorLiftGateChangeHandler}
                  />{" "}
                  Backdoor Lift Gate
                </Label>
              </FormGroup>
            </Col>
          </Row>
          <Row form className="pl-2 pr-2">
            <Col xs={12} className="mt-4 pl-4 pr-4">
              <FormGroup>
                <Label>Description (Areas Covered, Miles per day, moves freight for, starting location, etc.)</Label>
                <Input
                  type="textarea"
                  style={{ height: 120 }}
                  value={this.state.description ? this.state.description : ""}
                  onChange={this.descriptionChangeHandler}
                  placeholder="Enter a description"
                />
              </FormGroup>
            </Col>
          </Row>
          {this.props.edit && (
            <Row>
              <Col xs={12}>
                <FormGroup className="files">
                  <FileUpload fileChangeHandler={this.truckImageChangeHandler} />
                </FormGroup>
              </Col>
            </Row>
          )}
          <Row form className="pl-2 pr-2 pb-3 pt-2">
            <Col xs={12} className="pl-4 pr-4">
              {this.props.edit ? (
                <Button style={buttonStyle} color="danger" onClick={this.deleteTruckHandler}>
                  Delete
                </Button>
              ) : null}
              <Button style={buttonStyle} color="primary" onClick={this.onFormSubmitHandler}>
                {this.props.edit ? "Save" : "Add"}
              </Button>
            </Col>
          </Row>
          {this.props.edit && (
            <Row>
              <Col xs={12}>
                <Table
                  title="Open Fix List Items"
                  id="truck-fix-list-table"
                  headers={this.truckFixListHeaders}
                  data={this.state.truckFixListData}
                  buttons={this.truckFixListButtons}
                  sectionStyle={sectionStyle}
                  colors={["#FC575E", "#F7B42C"]}
                />
              </Col>
              <Button style={{ marginLeft: 25 + "px" }} onClick={this.newProblemModal}>
                {" "}
                New Fix List Item{" "}
              </Button>
            </Row>
          )}
          {this.state.closedFixListShow && (
            <Row>
              <Col xs={12}>
                <Table
                  title="Closed Fix List Items"
                  id="truck-closed-fix-list-table"
                  headers={this.truckFixListHeaders}
                  data={this.state.closedTruckFixListData}
                  buttons={this.truckFixListButtons}
                  sectionStyle={sectionStyle}
                  colors={["#BCBEC2", "#E1E4E8"]}
                />
              </Col>
            </Row>
          )}
          {this.props.edit && (
            <Row>
              <Col xs={12}>
                <Table
                  title="Truck Images"
                  id="truck-images-table"
                  headers={this.truckPictureHeaders}
                  data={this.state.truckPictures}
                  buttons={this.truckPictureButtons}
                  sectionStyle={sectionStyle}
                  enableLightbox={enableLightbox}
                  lightboxIndex={this.state.lightboxIndex}
                  showLightbox={this.state.showLightbox}
                />
              </Col>
              <Col xs={12}>
                <div style={{ padding: '10px ' }}>
                  <div style={{
                        color: '#04103B',
                        fontWeight: '400',
                        fontSize: '20px',
                        marginBottom: '12px',
                        marginLeft: '13px'
                  }}>{`Tagged Truck Images`}</div>
                  {this.state.taggedTrucks.length > 0 && this.state.taggedTrucks[0]?.image_urls.length > 0 && this.state.taggedTrucks.map((entry, index) => {
                    const guessedTimezone = moment.tz.guess();
                    return (
                    <Accordion key={index}>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="subtitle1">{moment.tz(entry.grouping_date, guessedTimezone).format('MMMM, YYYY')}</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid container spacing={2}>
                          {entry.image_urls.map((image, imageIndex) => (
                            <Grid item xs={12} sm={6} md={3} key={imageIndex}>
                              <img
                                onClick={() => this.openFullScreen(imageIndex, index)}
                                src={image}
                                alt={`Image ${imageIndex}`}
                                style={{
                                  width: '200px',
                                  height: '200px',
                                  objectFit: 'cover',
                                  cursor: 'pointer'
                                }}
                              />
                            </Grid>
                            
                          ))}
                          {this.state.fullScreen &&
                    <FullScreenModal>
                      <HighlightOffIcon onClick={() => this.closeFullScreen()} style={{ position: 'absolute', top: 15, right: 15, cursor: 'pointer', color: 'white' }} /> 
                      <div style={{ color: 'white' }}>
                          {this.state.isImageDownloading ?
                            <Spinner style={{ position: 'absolute', height: 20, width: 20, top: 16, right: 50, cursor: 'not-allowed', color: 'white' }}></Spinner>
                            :
                            <DownloadIcon onClick={() => this.handleDownload(this.state.taggedTrucks[this.state.accordainIndex].image_urls[this.state.currentImage])} style={{ position: 'absolute', top: 16, right: 50, cursor: 'pointer' }} />
                          }
                        </div>
                        {this.state.currentImage !== 0 && (
                          <Arrow direction="left" onClick={()=>this.previousImage()}>←</Arrow>
                        )}
                        <Image width="auto" src={this.state.taggedTrucks[this.state.accordainIndex].image_urls[this.state.currentImage]} alt="message" />
                        {this.state.currentImage !== this.state.taggedTrucks[this.state.accordainIndex].image_urls.length - 1 && (
                          <Arrow direction="right" onClick={()=>this.nextImage()}>→</Arrow>
                        )}
                      </FullScreenModal> }
                          
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  )})}
                </div>
              </Col>
            </Row>
          )}
        </Form>

        {this.props.edit && (
          <EditProblemModal
            show={this.state.problemModalShow}
            toggleModal={this.toggleProblemModal}
            edit={this.state.problemModalEdit}
            data={this.state.problemModalData}
            truckPageId={this.state.truckId}
          />
        )}
      </Fragment>
    );
  }
}

export default withRouter(TruckForm);
